import DateFnsUtils from '@date-io/date-fns';
import Intercom from '@intercom/messenger-js-sdk';
import { CssBaseline, Fade } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PropTypes from 'prop-types';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { Backdrop } from 'evee-ui-common/components/base';
import { history } from 'evee-ui-common/services';
import { appInit } from 'store/modules/app/actions';
import CookieNotification from 'widgets/layout/CookieNotification';
import ErrorFallback from 'widgets/layout/ErrorFallback';
import ScrollToTop from 'widgets/layout/ScrollToTop';
import Toast from 'widgets/layout/Toast';

import RootRouter from '../pages/router';
import theme from '../theme';
import AuthDialogs from '../widgets/dialogs/AuthDialogs';

let isIntercomInitialized = false;

const App = ({ onLoad, isInitComplete, isLoading }) => {
  useEffect(() => {
    if (isIntercomInitialized) return;

    Intercom({
      app_id: 'dvqcgyy5',
      z_index: 1000000,
    });

    isIntercomInitialized = true;
  }, []);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Fade mountOnEnter in={isInitComplete} timeout={500}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Suspense fallback={<Backdrop loading />}>
                <Router history={history}>
                  <ScrollToTop>
                    <RootRouter />
                  </ScrollToTop>
                </Router>
              </Suspense>
            </ErrorBoundary>
            <Toast />
            <AuthDialogs />
            <Backdrop loading={isLoading} />
            <CookieNotification />
          </MuiPickersUtilsProvider>
        </Fade>
        <Backdrop transparent={false} loading={!isInitComplete} />
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
};

App.propTypes = {
  onLoad: PropTypes.func.isRequired,
  isInitComplete: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ app }) => ({
  ...app,
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => dispatch(appInit()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
